import React from 'react';
import type { FC } from 'react';
import useAuth from 'src/hooks/useAuth';
import UserTypeAhead from './UserTypeAhead';
import { VendorUser } from 'src/types/vendorUser';

declare interface Props {
  onChange: (value: NonNullable<string | VendorUser>) => void;
  children?: React.ReactNode;
  style?: React.CSSProperties;
}

const UserDropdown: FC<Props> = ({ onChange, style }) => {
  const { hasImpersonateVendorAuth } = useAuth();

  if (hasImpersonateVendorAuth()) {
    return <UserTypeAhead onChange={onChange} style={style} />;
  }

  return <></>;
};

export default UserDropdown;
